<template>
  <el-dialog
      :title="$t('invoicesCenter.trackdialogTitle')"
      width="60%"
      append-to-body
      top="8vh"
      :visible.sync="dialogVisible"
      @close="close">
    <div class="track-info">
      <div>
        <span>{{$t('invoicesCenter.trackdialogSender')}}</span>
        {{expressNo.senderInfoName}}
      </div>
        <div>
            <span>{{$t('invoicesCenter.trackdialogContact')}}</span>
            {{ expressNo.contact }}
        </div>
        <div>
            <span>{{$t('invoicesCenter.trackdialogSenderaddr')}}</span>
            {{ expressNo.senderAddr }}
        </div>
      <div>
        <span>{{$t('invoicesCenter.trackdialogLogisticsname')}}</span>
        {{expressNo.logisticsName}}
      </div>
      <div>
        <span>{{$t('invoicesCenter.trackdialogExpressno')}}</span>
        {{expressNo.expressNo}}
      </div>
      <!-- <div>
        <span>{{$t('invoicesCenter.trackdialogDeliverytime')}}</span>
        {{deliveryPromiseTimeStr?deliveryPromiseTimeStr:''}}
        <el-button style="margin-left: 10px" v-if="!deliveryPromiseTimeStr" :loading="loading" type="primary" size="small" @click="estimatedTimeIng" >{{$t('invoicesCenter.trackdialogQuerybtn')}}</el-button>
      </div> -->
    </div>
    <el-table
        v-if="expressNo.queryType == 0"
        border
        :data="trackInfoList"
        :header-cell-style="{background:'#F3F4F7',color:'#555',padding: '5px 0'}"
        :cell-style="{padding: '5px 0'}">
      <el-table-column
          :label="$t('invoicesCenter.trackdialogTableindex')"
          type="index"
          align="center"
          width="100">
      </el-table-column>
      <el-table-column
          prop="opeTime"
          :label="$t('invoicesCenter.trackdialogTabletime')"
          align="center"
          width="300">
      </el-table-column>
      <el-table-column
          prop="opeRemark"
          :label="$t('invoicesCenter.trackdialogTabletrack')"
          align="center">
      </el-table-column>
    </el-table>
    <webview v-else :src="src" style="width: 100%; height: 500px;"></webview>
  </el-dialog>
</template>

<script>
import {erp2OperatingReceiveTraceGet,QueryEstimatedDeliveryTimeByExpressSn} from '@/libs/http/modules/erp.js'
export default {
  name: 'trackDialog',
  props: ['expressNo'],
  data(){
    return{
      dialogVisible: false,
      trackInfoList: [],
      receiverAddress: '',
      receiverPhone: '',
      src: '',
      loading:false,
      deliveryPromiseTimeStr:"",
    }
  },
  created(){
    this.dialogVisible = true;
    if(this.expressNo.queryType == 0){
      this.fetchLogis();
    }else{
      this.src = `https://www.yto.net.cn/tracesimple.html/?orders=${this.expressNo.expressNo}`
    }
  },
  methods: {
    estimatedTimeIng () {
      this.loading = true
      QueryEstimatedDeliveryTimeByExpressSn({
        expressSn: this.expressNo.expressNo,
      },).then(res => {
        this.loading = false
        if(res.code=='0') {
          this.deliveryPromiseTimeStr = res.data.deliveryPromiseTimeStr
        }else{
          this.$message({ type: 'error', message: res.msg, duration: 2000, showClose: true })
        }
      }).catch(err => {
        this.loading = false
        this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
      })
    },
    close(){
      this.dialogVisible = false;
      this.$emit('close');
    },
    fetchLogis(){
        erp2OperatingReceiveTraceGet({
            waybillCode: this.expressNo.expressNo,
            logisticsId: this.expressNo.logisticsId,
      }).then(data=>{
        if(data){
          this.trackInfoList = data.items || [];
        }
      }).catch(error=>{
        this.$message({ type: 'error', message: error, duration: 2000, showClose: true });
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.track-info{
  display: flex;
  flex-wrap: wrap;
  margin-top: -20px;
  margin-bottom: 20px;
  div{
    color: #000;
    width: calc(100% / 3);
    display: flex;
    span{
      width:180px;
      color: #666;
    }
  }
}
</style>
